<template>
  <div class="divider">
    <span>
      <slot>{{ text }}</slot>
    </span>
    <slot name="title"></slot>
  </div>
</template>

<script>
export default {
  name: "divider-separator",
  props: {
    text: {
      type: String,
      default: "OR"
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.divider {
  display: block;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  margin: 20px 0;
  padding: 1em 0;
  width: 100%;

  &.compact {
    margin: 0;
  }

  &.wide {
    overflow: visible;
  }

  &:last-child {
    margin-bottom: 0;
  }

  span {
    position: relative;
    display: inline-block;
    font-size: 1em;
    color: #000;

    &:before,
    &:after {
      width: 500px;
      content: "";
      height: 1px;
      background-color: rgba(0, 0, 0, 0.1);
      position: absolute;
      top: 50%;
    }

    &:before {
      right: 100%;
      margin-right: 20px;
    }

    &:after {
      left: 100%;
      margin-left: 20px;
    }
  }

  &.light {
    span {
      color: rgba(255, 255, 255, 0.3);

      &:before,
      &:after {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }
}
</style>
